import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { CloseIcon } from "../../../../assets/icons/social/close";
import { Link } from "@quintype/components";
import get from "lodash/get";

import "./request-subscription.m.css";

class RequestSubscriptionBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: true
    };
  }

  hideForm = event => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({ showForm: !this.state.showForm });
  };

  openLogin = event => {
    event.preventDefault();
    event.stopPropagation();
    this.props.openLoginTemplate();
  };

  render() {
    const publisherTitle = get(this.props, ["config", "publisher-settings", "title"], "Ahead");
    return (
      <div>
        {this.state.showForm && (
          <div styleName="metered-wrapper">
            <div onClick={event => this.hideForm(event)} styleName="close">
              <CloseIcon width="24" height="24" color={"#333"} />
            </div>
            <div styleName="metered-headline">Subscribe now to get unlimited access.</div>
            <p styleName="metered-desc">
              We’re glad you’re enjoying {publisherTitle}. You have no more free stories left. Subscribe to have
              unlimited access to all our stories
            </p>
            <div styleName="btn-wrapper">
              <div styleName="subscribe-btn">
                <Link href={"/subscription"}>Subscribe</Link>
              </div>
              {!this.props.member && (
                <span styleName="info-text">
                  Already a user? <a onClick={this.openLogin}>Login</a>
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

RequestSubscriptionBase.propTypes = {
  member: PropTypes.object,
  openLoginTemplate: PropTypes.func
};

const mapStateToProps = state => ({
  member: get(state, ["member"], null),
  config: get(state, ["qt", "config"], {})
});

const mapDispatchToProps = dispatch => ({
  openLoginTemplate: () => dispatch({ type: "OPEN_LOGIN_TEMPLATE" })
});

export const RequestSubscription = connect(
  mapStateToProps,
  mapDispatchToProps
)(RequestSubscriptionBase);
